import { render, staticRenderFns } from "./horse-thumb.vue?vue&type=template&id=1319dc56&"
import script from "./horse-thumb.vue?vue&type=script&lang=js&"
export * from "./horse-thumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports